import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import LockRoundedIcon from '@mui/icons-material/LockRounded';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import { CommonButton } from '../components';

interface ForbiddenPageProps {
  onGoHome?: () => void;
}

const ForbiddenPage: React.FC<ForbiddenPageProps> = ({ onGoHome }) => {
  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 64px)',
        display: 'grid',
        placeItems: 'center',
        p: { xs: 2, md: 4 },
        background: 'linear-gradient(180deg, #f8fcfd 0%, #eef6f8 100%)',
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: 860,
          borderRadius: 4,
          border: '1px solid #e2eef1',
          backgroundColor: '#ffffff',
          boxShadow: '0 18px 40px rgba(76, 155, 171, 0.18)',
          px: { xs: 3, md: 6 },
          py: { xs: 5, md: 6 },
        }}
      >
        <Stack spacing={1.5} alignItems="center" textAlign="center">
          <LockRoundedIcon sx={{ fontSize: 52, color: '#2f7d8c' }} />
          <Typography sx={{ fontSize: { xs: 64, md: 96 }, fontWeight: 800, color: '#2f5f75', lineHeight: 1 }}>
            403
          </Typography>
          <Typography sx={{ fontSize: { xs: 22, md: 28 }, fontWeight: 700, color: '#2f7d8c' }}>
            Forbidden
          </Typography>
          <Typography sx={{ maxWidth: 520, color: '#5f7480' }}>
            You do not have permission to access this page. Contact your administrator if you need access.
          </Typography>
          {onGoHome ? (
            <CommonButton label="Back To Home" startIcon={<HomeRoundedIcon />} onClick={onGoHome} />
          ) : null}
        </Stack>
      </Box>
    </Box>
  );
};

export default ForbiddenPage;